import { GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";
import { FOUNDERS } from "@/data/content";
import { Eyebrow, Lotus } from "./Ornaments";

export const Founders = () => (
  <section id="founders" data-testid="founders-section" className="py-24 sm:py-32 bg-blush">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center mb-14">
        <Eyebrow className="justify-center">The people behind Nexora</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 leading-[1.05]">Meet our <span className="italic text-terra">founders.</span></h2>
      </Reveal>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-10 lg:gap-14" data-testid="founders-row">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name} delay={i * 0.12} className="text-center">
            <div className="w-36 sm:w-40 lg:w-44 mx-auto rounded-t-full rounded-b-[24px] overflow-hidden border-4 border-cream shadow-[0_25px_50px_-25px_rgba(201,107,82,0.55)] bg-cream">
              <img src={f.img} alt={f.name} className="w-full aspect-[4/5] object-cover object-top" />
            </div>
            <div className="mt-5 flex items-center justify-center gap-2">
              <Lotus className="w-6 h-4" />
              <h3 className="font-display text-2xl text-ink">{f.name}</h3>
            </div>
            <p className="text-xs tracking-[0.25em] uppercase text-terra-deep font-semibold mt-1">{f.role}</p>
            <p className="flex items-center justify-center gap-1.5 text-sm text-muted-ink mt-2.5">
              <GraduationCap size={15} className="text-sage-deep shrink-0" /> {f.edu}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
